import React from 'react'
import { useFeatureFlag } from '@fs/zion-flags'
import { SourceRailSkeleton } from '@fs/zion-source-list'
import CenteredLoadingSpinner from '../../../common/CenteredLoadingSpinner'
import useSourceCentricDetailsFlag from '../../../data-service/useSourceCentricDetailsFlag'

export default function SourcesCardSkeleton(): JSX.Element {
  const { data } = useSourceCentricDetailsFlag()
  const isSourceCentricOn = !!data?.isOn
  const clickableCards = useFeatureFlag('treeWebTx_personR9_clickableSourceCards').isOn

  if (isSourceCentricOn) {
    return <SourceRailSkeleton clickableCards={clickableCards} />
  }

  return <CenteredLoadingSpinner />
}
